// extracted by mini-css-extract-plugin
export var equalColumn = "_fi-0";